// The workbook's Adstock sheet carries prior and posterior curves and fractional time units, so only
// the posterior rows on integer periods are charted. The Meridian per-file output has neither column
// (it is posterior-only on integer periods), so this runs on the workbook path alone.
export const keepPosteriorIntegerAdstock = <
  T extends { distribution?: unknown; is_int_time_unit?: unknown }
>(
  rows: T[]
): T[] => rows.filter(row => row.distribution === 'posterior' && row.is_int_time_unit);

// Per-sheet row cleanup for the workbook path; only the Adstock sheet needs it.
export const cleanWorkbookSheetRows = <
  T extends { distribution?: unknown; is_int_time_unit?: unknown }
>(
  sheetName: string,
  rows: T[]
): T[] => (sheetName === 'Adstock' ? keepPosteriorIntegerAdstock(rows) : rows);
